export default __webpack_public_path__ + "static/img-6-3a5c52ef1f201b088d78864f1134b0d6.png";